import { fetchWithCache, getCachedData } from "../services/apiService";

export const propertiesPopular = async ({ setPropertiesPopular }) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/property/popular", {});
  if (cached) {
    setPropertiesPopular(cached);
  }

  try {
    // Request fresh data and fall back to cache if needed
    const data = await fetchWithCache(
      "/api/property/popular",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    if (typeof setPropertiesPopular === "function") {
      const list = Array.isArray(data) ? data : [];
      // Defensive filter: only include active properties with valid id and
      // exclude any soft-deleted records. This guards against stale or
      // inconsistent cached entries.
      const filtered = list.filter((p) => {
        if (!p || !p.property_id) return false;
        const status = (p.property_status || "").toString();
        if (status.toLowerCase() !== "active") return false;
        if (p.deleted === true || p.is_deleted === true) return false;
        return true;
      });
      // Remove duplicates by property_id
      const unique = [];
      const seen = new Set();
      for (const p of filtered) {
        if (!seen.has(p.property_id)) {
          seen.add(p.property_id);
          unique.push(p);
        }
      }
      setPropertiesPopular(unique);
    } else {
    }
  } catch (error) {
    if (typeof setPropertiesPopular === "function") {
      setPropertiesPopular([]);
    }
  }
};
